/**
 * Format a USD amount for display. Sub-dollar amounts (typical for a single
 * user's spend) show up to 4 decimals so cents don't round away to $0.00.
 */
export function formatCurrency(value: number, currency = 'USD'): string {
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: value !== 0 && Math.abs(value) < 1 ? 4 : 2,
  }).format(value);
}
